<template>
  <div>
    <div align="left">
      <br />
      <h5 class="font-weight-bold text-primary">Form Guide Book</h5>
      <br />
    </div>
    <b-row>
      <b-col md="6">
        <b-card class="text-left">
          <b>Edit Error Guide Book</b>
          <div v-if="loading">
            <b-spinner label="Spinning"></b-spinner>
          </div>
          <template v-else>
            <b-row class="mt-4">
              <b-col>
                <b-form-group
                  id="fieldset-1"
                  label="Error Code"
                  label-class="control-label"
                  class="required"
                  label-for="input-1"
                >
                  <input
                    v-validate="'required'"
                    v-model="error_code"
                    name="error_code"
                    data-vv-as="Error Code"
                    id="input-1"
                    class="form-control"
                    placeholder="Error Code"
                  />
                  <b-form-invalid-feedback id="input-error_code-feedback">{{
                    veeErrors.first("error_code")
                  }}</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group
                  id="fieldset-1"
                  label="Location"
                  label-class="control-label"
                  class="required"
                  label-for="input-1"
                >
                  <input
                    v-validate="'required'"
                    v-model="location"
                    name="location"
                    data-vv-as="Location"
                    id="input-1"
                    class="form-control"
                    placeholder="Location"
                  />
                  <b-form-invalid-feedback id="input-location-feedback">{{
                    veeErrors.first("location")
                  }}</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group
                  id="fieldset-1"
                  label="Description"
                  label-class="control-label"
                  class="required"
                  label-for="input-1"
                >
                  <textarea
                    v-validate="'required'"
                    v-model="description"
                    name="description"
                    data-vv-as="Description"
                    id="input-1"
                    class="form-control"
                    placeholder="Description"
                  />
                  <b-form-invalid-feedback id="input-description-feedback">{{
                    veeErrors.first("description")
                  }}</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group
                  id="fieldset-1"
                  label="Cause By"
                  label-class="control-label"
                  class="required"
                  label-for="input-1"
                >
                  <input
                    v-validate="'required'"
                    v-model="cause_by"
                    name="cause_by"
                    data-vv-as="Cause By"
                    id="input-1"
                    class="form-control"
                    placeholder="Cause By"
                  />
                  <b-form-invalid-feedback id="input-cause_by-feedback">{{
                    veeErrors.first("cause_by")
                  }}</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>
            <br />
            <b-row class="text-right">
              <b-col>
                <b-button variant="primary" class="mr-3" @click="edit()" size="lg">
                  Save
                  <b-spinner v-if="loading" small label="Loading..."></b-spinner>
                </b-button>
                <router-link :to="{ name: 'GuideBook' }">
                  <b-button variant="outline-secondary" size="lg">Cancel</b-button>
                </router-link>
              </b-col>
            </b-row>
          </template>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      error_code: "",
      location: "",
      description: "",
      cause_by: ""
    };
  },
  async mounted() {
    this.loading = true;
    try {
      const res = await this.$store.dispatch(
        "GuideBookModule/getGuideBookDetail",
        this.$route.params.id
      );
      this.error_code = res.error_code;
      this.location = res.location;
      this.description = res.description;
      this.cause_by = res.cause_by;
    } catch (err) {
      console.log({ err });
    } finally {
      this.loading = false;
    }
  },
  methods: {
    edit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.loading = true;
          const payload = {
            id: this.$route.params.id,
            error_code: this.error_code,
            location: this.location,
            description: this.description,
            cause_by: this.cause_by
          };
          this.$store
            .dispatch("GuideBookModule/editGuideBook", payload)
            .then(response => {
              this.loading = false;
              this.$router.push({ name: "GuideBook" });
              this.$swal({
                type: "success",
                title: "Guide Book Successfully Edited",
                showConfirmButton: false,
                timer: 1500
              });
              console.log(response);
            })
            .catch(error => {
              this.loading = false;
              this.$swal({
                type: "error",
                title: "Oops...",
                text: error.response.data.message || "Something Went Wrong",
                showConfirmButton: false,
                timer: 1500
              });
              console.log(error);
            });
        }
      });
    }
  }
};
</script>

<style></style>
